export default __webpack_public_path__ + "static/InstagramButton-a04e6dd1d032883cc286078a80462bff.svg";